import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./auth/msalConfig";
import Authorize from "./Pages/ControlTower/Authorize";
import CTDashboard, { ExpandableWidget } from "../src/Pages/ControlTower/CTDashboard/CTDashboard";
import { Provider } from "react-redux";
import ErrorPage from "./ErrorHandling/ErrorPage";
import { store } from "./redux/store";
import PrivateRoutes, { controlTowerMenuItems } from "./routes/PrivateRoutes";
import InboundShipmentDetail from "./Pages/ControlTower/InboundShipment/InboundShipmentDetail";
import InboundDeliveryDetail from "./Pages/ControlTower/InboundDeliveries/InboundDeliveryDetail";
import InboundOrderDetail from "./Pages/ControlTower/InboundOrders/InboundOrderDetail";
import TableLayout from "./Components/CommonTableLayout/TableLayout";
import InboundShipmentTable from "./Pages/ControlTower/InboundShipment/InboundShipmentTable";
import InboundDeliveryTable from "./Pages/ControlTower/InboundDeliveries/InboundDeliveryTable";
import InboundOrderTable from "./Pages/ControlTower/InboundOrders/InboundOrderTable";
import OutboundShipmentTable from "./Pages/ControlTower/OutboundShipment/OutboundShipmentTable";
import OutboundShipmentDetail from "./Pages/ControlTower/OutboundShipment/OutboundShipmentDetail";
import OutboundDeliveryTable from "./Pages/ControlTower/OutbondDeliveries/OutboundDeliveryTable";
import OutboundDeliveryDetail from "./Pages/ControlTower/OutbondDeliveries/OutboundDeliveryDetail";
import OutboundOrderTable from "./Pages/ControlTower/OutboundOrders/OutboundOrderTable";
import OutboundOrderDetail from "./Pages/ControlTower/OutboundOrders/OutboundOrderDetail";
import InventoryTable from "./Pages/ControlTower/Inventory/InventoryTable";
import { HeaderBar } from "./Components/utils/HeaderBar";
import { AuthRedirect } from "./auth/authRedirect";
import AnalyticsPage from "./Pages/ControlTower/Analytics/AnalyticsPage";
import { InventoryDetail } from "./Pages/ControlTower/Inventory/InventoryDetail";
import CurrencyConverterTable from "./Pages/ControlTower/CurrencyConversion/CurrencyConverterTable";
import CurrencyConversionDetail from "./Pages/ControlTower/CurrencyConversion/CurrencyConversionDetail";
import AlertPreference from "./CommonComponents/TopSection/AlertPreference";
import AccessRequestForm from './Pages/ControlTower/UserRoles/AccessRequestForm';
import TrackAccessRequest from './Pages/ControlTower/UserRoles/TrackAccessRequest';
import AlertDetails from "../src/CommonComponents/TopSection/AlertDetails";
import UserAccessReport from './Pages/ControlTower/UserRoles/UserAccessReport';
import RequestAppovalDelegation from './Pages/ControlTower/UserRoles/RequestApprovalDelegation';
const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

const routes = controlTowerMenuItems.map((item) => ({
  path: item.path,
  element: (
    <>
      {/* <HeaderBar isSearchAndFilter={ false } /> */}
      <div style={{ padding: 20, fontSize: 18 }}>
        {" "}
        🚧 {item.label} – Coming Soon!{" "}
      </div>
    </>
  )
}));


const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Provider store={store}>
        <AuthRedirect>
          <App />
        </AuthRedirect>
      </Provider>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Navigate to="/ct-dashboard" replace />,
      },
      {
        path: "/ct-dashboard",
        element: <PrivateRoutes />,
        children: [
          {
            index: true,
            element: <ExpandableWidget>
              <CTDashboard />
            </ExpandableWidget>
            ,
          },
        ],
      },
      {
        path: "core/supply/shipment",
        element: <PrivateRoutes />,
        children: [
          {
            index: true,
            element: <TableLayout title="Inbound Shipment" component={InboundShipmentTable} />,
          },
          {
            path: "shipment-detail/:id",
            element: <PrivateRoutes />,
            children: [
              {
                index: true,
                element: <InboundShipmentDetail />,
              },
            ],
          },
        ],
      },
      {
        path: "core/supply/delivery",
        element: <PrivateRoutes />,
        children: [
          {
            index: true,
            element: <TableLayout title="Inbound Delivery" component={InboundDeliveryTable} />,
          },
          {
            path: "delivery-detail/:id",
            element: <PrivateRoutes />,
            children: [
              {
                index: true,
                element: <InboundDeliveryDetail />,
              },
            ],
          },
        ],
      },
      {
        path: "core/supply/order",
        element: <PrivateRoutes />,
        children: [
          {
            index: true,
            element: <TableLayout title="Inbound Orders" component={InboundOrderTable} />,
          },
          {
            path: "order-detail/:type/:id",
            element: <PrivateRoutes />,
            children: [
              {
                index: true,
                element: <InboundOrderDetail />,
              },
            ],
          },
        ],
      },
      {
        path: "core/demand/shipment",
        element: <PrivateRoutes />,
        children: [
          {
            index: true,
            element: <TableLayout title="Outbound Shipment" component={OutboundShipmentTable} />,
          },
          {
            path: "shipment-detail/:id",
            element: <PrivateRoutes />,
            children: [
              {
                index: true,
                element: <OutboundShipmentDetail />,
              },
            ],
          },
        ],
      },
      {
        path: "core/demand/delivery",
        element: <PrivateRoutes />,
        children: [
          {
            index: true,
            element: <TableLayout title="Outbound Delivery" component={OutboundDeliveryTable} />,
          },
          {
            path: "delivery-detail/:id/:shipFrom",
            element: <PrivateRoutes />,
            children: [
              {
                index: true,
                element: <OutboundDeliveryDetail />,
              },
            ],
          },
        ],
      },
      {
        path: "core/demand/order",
        element: <PrivateRoutes />,
        children: [
          {
            index: true,
            element: <TableLayout title="Outbound Orders" component={OutboundOrderTable} />,
          },
          {
            path: "order-detail/:id",
            element: <PrivateRoutes />,
            children: [
              {
                index: true,
                element: <OutboundOrderDetail />,
              },
            ],
          },
        ],
      },
      {
        path: "core/inventory/node/inventory",
        element: <PrivateRoutes />,
        children: [
          {
            index: true,
            element: <TableLayout title="Inventory" component={InventoryTable} />,
          },
          {
            path: "inventory-detail/:itemNo/:siteCode",
            element: <PrivateRoutes />,
            children: [
              {
                index: true,
                element: <InventoryDetail />,
              },
            ],
          },
        ],
      },
      {
        path: "core/analytics",
        element: <PrivateRoutes />,
        children: [
          {
            index: true,
            element: <AnalyticsPage />,
          },
        ],
      },
      {
        path: "core/master-data/currency-conversion",
        element: <PrivateRoutes />,
        children: [
          {
            index: true,
            element: <TableLayout title="Currency Conversion" component={CurrencyConverterTable} />,
          },
          {
            path: "conversion-detail/:id",
            element: <PrivateRoutes />,
            children: [
              {
                index: true,
                element: <CurrencyConversionDetail />,
              },
            ],
          },
        ],
      },
      {
        path: "core/preferences/alert-preferences",
        element: <PrivateRoutes />,
        children: [
          {
            index: true,
            element: <AlertPreference />,
          },
        ],
      },
      {
        // path: "core/user-roles",
        // element: <PrivateRoutes />,
        children: [
          {
            path: "core/user-roles/new-request",
            element: <PrivateRoutes />,
            children: [
              {
                index: true,
                element: <AccessRequestForm />,
              },
            ],
          },
          {
            path: "core/user-roles/track-access-request",
            element: <PrivateRoutes />,
            children: [
              {
                index: true,
                element: <TrackAccessRequest />,
              },
            ],
          },
          {
            path: "core/user-roles/reports",
            element: <PrivateRoutes />,
            children: [
              {
                index: true,
                element: <UserAccessReport />,
              },
            ],
          },
          {
            path: "core/user-roles/approval-rights",
            element: <PrivateRoutes />,
            children: [
              {
                index: true,
                element: <RequestAppovalDelegation />,
              },
            ],
          },
        ],
      },
      {
        path: "alerts",
        element: <PrivateRoutes />,
        children: [
          {
            path: ":domain",
            element: <AlertDetails />,
          },
        ],
      },
      ...routes],
  },
  {
    path: "/core/authorize",
    element: <Authorize />,
  }
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <RouterProvider router={router} />
    </MsalProvider>
  </React.StrictMode>
);

reportWebVitals();